import { render, staticRenderFns } from "./TaskShortId.vue?vue&type=template&id=389c46ed&"
import script from "./TaskShortId.vue?vue&type=script&lang=ts&"
export * from "./TaskShortId.vue?vue&type=script&lang=ts&"
import style0 from "./TaskShortId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports